import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Breadcrumb } from "react-bootstrap";
// import StoreTable from "../../components/backend/store/StoreTable";
import SessionService from "../../service/SessionService";
import StoreService from "../../service/store/StoreService";
import IndexTable from "../../components/common/IndexTable";

function Stores({ loading, setLoading }) {
	const pageTitle = "Stores | RTO Mobile";

	return (
		<>
			<Helmet>
				<title>{pageTitle}</title>
				<meta name="robots" content="noindex,nofollow"></meta>
				<meta property="og:title" content={pageTitle} />
				<meta name="twitter:title" content={pageTitle} />
			</Helmet>
			<div className="rto_form-sections">
				<div className="rto_content-div" style={{ maxWidth: "1600px" }}>
					<Breadcrumb
						listProps={{ className: "w-100 justify-content-end" }}
					>
						<Breadcrumb.Item
							linkAs={Link}
							linkProps={{ to: "/dashboard" }}
						>
							Dashboard
						</Breadcrumb.Item>
						<Breadcrumb.Item
							linkAs={Link}
							linkProps={{ to: "/settings" }}
						>
							Settings
						</Breadcrumb.Item>

						<Breadcrumb.Item active>Stores</Breadcrumb.Item>
					</Breadcrumb>
					<div className="rto_title-div">
						<h1 className="rto_page-title">Stores</h1>
					</div>
					<p className="text-center">
						{SessionService.canRtoAdmin() && (
							<Link
								className="btn btn-primary"
								to="/settings/stores/create"
							>
								Create
							</Link>
						)}
					</p>
					<div
						className="card card-outline card-primary"
						style={{
							borderTop: "3px solid #00aaff",
							boxShadow:
								"0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
						}}
					>
						<div className="card-body">
							{/* <StoreTable
								loading={loading}
								setLoading={setLoading}
							/> */}
							<IndexTable
								model={"struct_store"}
								loading={loading}
								setLoading={setLoading}
								service={StoreService}
								title="Stores"
								actionButtons={
									SessionService.canRtoAdmin() && {
										updateLink: {
											path: "/settings/stores",
										},
										// updateModal: {
										// 	enabled: true,
										// 	path: "/settings/stores/update",
										// },
										// create: {
										// 	enabled: true,
										// 	path: "/settings/stores/create",
										// },
									}
								}
								labels={[
									{
										id: "id",
										label: "ID",
									},
									{
										id: "struct_iso_name",
										label: "ISO",
										link: "/settings/isos",
									},
									{
										id: "struct_master_agent_name",
										label: "Master Agent",
										link: "/settings/master-agents",
									},
									{
										id: "struct_organization_name",
										label: "Organization",
										link: "/settings/organizations",
									},
									{
										id: "struct_company_name",
										label: "Company",
										link: "/settings/companies",
									},
									{
										id: "struct_store_name",
										label: "Store",
										link: "/settings/stores",
									},
									{
										id: "account_manager",
										label: "Account Manager",
									},
									{
										id: "address_1",
										label: "Address 1",
									},
									{
										id: "address_2",
										label: "Address 2",
										initialDisplay: false,
									},
									{
										id: "city",
										label: "City",
									},
									{
										id: "state",
										label: "State",
									},
									{
										id: "zip",
										label: "Zip",
										initialDisplay: false,
									},
									{
										id: "phone",
										label: "Phone",
									},
									{
										id: "email",
										label: "Email",
									},
									{
										id: "card_connect_merchant_id",
										label: "CardConnect Merch ID",
									},
									{
										id: "store_saas_rate_plan_description",
										label: "Subscription",
									},
									{
										id: "status_name",
										label: "Status",
									},
									{
										id: "guarantee_status_name",
										label: "Guarantee Status",
									},
									{
										id: "timezone",
										label: "Timezone",
									},
									{
										id: "event_hour_abp",
										label: "ABP Run Time",
									},
									{
										id: "event_hour_lock",
										label: "Lock Run Time",
									},
									{
										id: "abp_number_of_attempts",
										label: "ABP Card Attempts",
									},
									{
										id: "lock_number_of_days_past_invoice",
										label: "Engage Lock Days",
									},
									{
										id: "created",
										label: "Created At",
									},
									{
										id: "user_username",
										label: "Created By",
									},
								]}
								apiBase="/store"
								successRedirectBase="settings/stores"
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Stores;
